export interface TypographyStyles {
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: string;
}

export const TYPOGRAPHY_KEYS: ReadonlyArray<keyof TypographyStyles> = [
  "fontFamily",
  "fontStyle",
  "fontWeight",
] as const;

export function mergeTypographyStyles(
  overrides: TypographyStyles,
  theme: TypographyStyles,
): TypographyStyles {
  const result: TypographyStyles = {};

  for (const key of TYPOGRAPHY_KEYS) {
    const value = overrides[key] || theme[key];
    if (value) {
      result[key] = value;
    }
  }

  return result;
}
